import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Initialize i18next
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'uk',
    fallbackLng: 'uk',
    defaultNS: 'common',
    ns: ['common', 'catalog', 'cart', 'checkout', 'admin', 'auth', 'home', 'services'],

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'emlab-language'
    },

    interpolation: {
      escapeValue: false // React already escapes values
    },

    // Available languages
    supportedLngs: ['en', 'ru', 'uk'],

    // Debug mode for development
    debug: import.meta.env.DEV
  });

export default i18n;
